import React from 'react';

const features = [
  {
    title: 'Attendance Tracking',
    desc: "Mark students present, absent, tardy, or excused with a couple of clicks. It's like roll call, but without the paper or the shouting.",
  },
  {
    title: 'Role-Based Dashboards',
    desc: "Admins see everything. Teachers see only their classes. Everyone sees a cleaner way to manage attendance.",
  },
  {
    title: 'Class & Roster Management',
    desc: "Create classrooms, assign teachers, and enroll students—without needing a spreadsheet open on the side.",
  },
  {
    title: 'Exportable Reports',
    desc: "Pull attendance records into a clean CSV file. Yes, it works with Excel. No, you don't need to install anything extra.",
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="bg-blue-600 text-white py-16 px-4 text-center">
      <h2 className="text-3xl md:text-4xl font-bold mb-2">Everything you need to digitize your attendance.</h2>
      <p className="mb-10 text-blue-100 max-w-xl mx-auto">Stay ontop of your students' attendance with our user-friendly solution.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
        {features.map((f) => (
          <div key={f.title} className="bg-white/10 rounded-lg p-6 text-left shadow-md">
            <h3 className="font-semibold text-lg mb-2">{f.title}</h3>
            <p className="text-blue-100 text-sm">{f.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
} 